/**
 * Constructor for the Polling request
 *
 * @param {string} listener
 * @param {Number} timeout in milliseconds
 * @param {callback} callback
 * @param {boolean} active
 * @constructor
 */
const Polling = function (listener, timeout, callback, active) {
    // the attributes are prefixed with 'polling' to assure their uniqueness,
    // since there are no private attributes in JS.
    this.pollingListener = listener;
    this.pollingTimeout = timeout;
    this.pollingCallback = callback;
    this.pollingActive = active;
};

Polling.prototype = {
    /**
     * Returns the listener.
     *
     * @return {string}
     */
    getListener: function () {
        return this.pollingListener;
    },

    /**
     * Returns the timeout.
     *
     * @return {Number}
     */
    getTimeout: function () {
        return this.pollingTimeout;
    },

    /**
     * Returns the callback function.
     *
     * @return {callback}
     */
    getCallback: function () {
        return this.pollingCallback;
    },

    /**
     * Tells if the polling request should be sent.
     *
     * @return {boolean}
     */
    isActive: function () {
        return this.pollingActive;
    },

    /**
     * Activates the polling
     *
     * @return {boolean}
     */
    activate: function () {
        this.pollingActive = true;
    },

    /**
     * Deactivates the polling.
     *
     * @return {boolean}
     */
    deactivate: function () {
        this.pollingActive = false;
    }
};

export default Polling;
